jQuery(document).ready(function ($) {
  $('.wpcf7 .screen-reader-response').remove();
  // Styliser les input select
  $('.wpcf7 select').selectmenu();

  // Gestion du style des checkboxs
  $('.wpcf7 input[type=checkbox]').each(function () {
    var elem = jQuery(this);
    elem.parent().wrap('<div class="checkcheckboxstyle"></div>');
    elem
      .parent()
      .prepend(
        '<span class="tick"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.96 9.2"><path d="M4.11 6L2.25 4.14a1.31 1.31 0 0 0-1.86 0A1.33 1.33 0 0 0 .39 6l2.8 2.81A1.31 1.31 0 0 0 5 8.82l6.53-6.56a1.33 1.33 0 0 0 0-1.87 1.31 1.31 0 0 0-1.85 0z" /></svg></span>'
      );
  });

  // Gestion du comportement des checkboxs
  $('.wpcf7 input[type=checkbox]').on('change', function () {
    var elem = $(this);
    if (elem.parent().parent().find('input').prop('checked')) {
      elem.parent().find('.tick').addClass('active');
    } else {
      elem.parent().find('.tick').removeClass('active');
    }
  });
  // validation de (mail/phone/zipcode) au Focus out et animation label
  const field = $('.profile-health-contact__form .wpcf7-form-control-wrap input[type=text], .profile-health-contact__form .wpcf7-form-control-wrap input[type=email], .profile-health-contact__form .wpcf7-form-control-wrap textarea')
  const fieldEmail = $('.profile-health-contact__form .wpcf7-form-control-wrap input[name=your-email]');
  const fieldZipCode = $('.profile-health-contact__form .wpcf7-form-control-wrap input[name=your-postalcode]');
  const fieldPhone = $('.profile-health-contact__form .wpcf7-form-control-wrap input[name=your-phone]');

  $(field).each(function(index, item){
    if($(item).val() !== '') {
      var getLabel = $(this).parent().prev("label").detach();
      $(this).after(getLabel);
      $(this).addClass('labelInside');  
    } else {
      $(this).removeClass('labelInside');
    }
  });

  field.on('focus blur', OnFocus );
  function OnFocus(e){
    if( (e.type == 'focus') || ($(this).val()) ){ 
      var getLabel = $(this).parent().prev("label").detach();
      $(this).after(getLabel);
      $(this).addClass('labelInside');
    } else {
      $(this).removeClass('labelInside');
    }
  }

  
  $( fieldEmail ).focusout(function() {
    var fieldEmailVal = fieldEmail.val();
    if($(this).val()){
      if( !validateEmail(fieldEmailVal)) { 
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Adresse email invalide.</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }else{
      $(this).parent().find('.wpcf7-not-valid-tip').remove();
      $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
    }
  })

  $( fieldZipCode ).focusout(function() {
    var fieldZipCodeVal = fieldZipCode.val();
    if($(this).val()){
      if( !validateZipCode(fieldZipCodeVal)) { 
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Le champ doit contenir exactement 5 caractères. Si vous n’êtes pas résident Français, nous vous invitons à contacter nos équipes commerciales au 03 21 23 83 00</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }else{
      $(this).parent().find('.wpcf7-not-valid-tip').remove();
      $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
    }
  })

  $( fieldPhone ).focusout(function() {
    var fieldZipCodeVal = fieldPhone.val();
    if($(this).val()){
      if( !validatePhone(fieldZipCodeVal)) { 
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Le champ doit contenir exactement 10 caractères</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }else{
      $(this).parent().find('.wpcf7-not-valid-tip').remove();
      $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
    }
  })

  function validateEmail($email) {
    var emailReg = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return emailReg.test( $email );
  }

  function validatePhone($phone) {
    var emailReg = /^[0-9]{10}$/g;
    return emailReg.test( $phone );
  }

  function validateZipCode($zipcode) {
    var zipcodeReg = /^[0-9]{5}$/g;
    return zipcodeReg.test( $zipcode );
  }






  /* function OnFocusOutMail(e){
    if ((e.type == 'focusout') && ($(this).prop('type') == 'email') && ($(this).val())){
      var fieldMail = ($(this).val());
      if(!patternMail.test(fieldMail))
      {
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Adresse email invalide.</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }
  } */

  /* function OnFocusOutPhone(e){
    if ((e.type == 'focusout') && ($(this).prop('name') == 'your-phone') && ($(this).val())){
      var fieldPhone = ($(this).val());
      if(!patternPhone.test(fieldPhone))
      {
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Le champ doit contenir exactement 10 caractères.</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }
  } */
  /* function OnFocusOutZipCode(e) {
    if ((e.type == 'focusout') && ($(this).prop('name') == 'your-postalcode') && ($(this).val())){
      var fieldPhone = ($(this).val());
      if(!patternZipCode.test(fieldPhone))
      {
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $(this).parent().find('label').after('<span class="wpcf7-not-valid-tip" aria-hidden="true">Le champ doit contenir exactement 5 caractères. Si vous n’êtes pas résident Français, nous vous invitons à contacter nos équipes commerciales au 03 21 23 83 00.</span>');
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', true);
      }else{
        $(this).parent().find('.wpcf7-not-valid-tip').remove();
        $('.profile-health-contact__form input[type="submit"]').prop('disabled', false);
      }
    }
  } */
});
